export enum AuthMethodType {
  Password = 'password',
  Shibboleth = 'shibboleth',
  Ldap = 'ldap',
  Ip = 'ip',
  Oidc = 'oidc',
  Orcid = 'orcid'
}
